function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.089 23.983a.903.903 0 01-.127-.008H2.03a1.065 1.065 0 01-1.18-.89 1.066 1.066 0 01.161-.758l10.091-20.18c.291-.583.722-.645.894-.645.214 0 .614.084.894.645l10.091 20.181a1.076 1.076 0 01-.269 1.454 1.064 1.064 0 01-.623.201zM1.891 22.805a.462.462 0 01-.041.067.067.067 0 00-.013.052.07.07 0 00.066.058.582.582 0 01.093-.008h20c.027 0 .054.002.081.007h.008c.02 0 .031-.004.042-.012a.069.069 0 00.016-.096.443.443 0 01-.041-.067L11.996 2.594 1.891 22.805z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.996 17.479a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5zM12.01 19.979a.758.758 0 01-.763-.725.756.756 0 01.207-.543.735.735 0 01.524-.231.765.765 0 01.768.726.756.756 0 01-.207.543.739.739 0 01-.524.231l-.005-.001z"
});

function SvgFormWarning(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "formWarning.7b8ae.svg";
export { SvgFormWarning as ReactComponent };